import { getMuiThemeBase } from 'swag-client-common/styles/mui/get-mui-theme-base';
export const muiTheme = getMuiThemeBase();